const hexToRGBA = (hex: string, opacity: number) => {
  const cleanedHex = hex.replace('#', '');
  const rgbaColor = `rgba(${cleanedHex
    .match(new RegExp(`(.{${cleanedHex.length / 3}})`, 'g'))
    .map(function parseHex(l) {
      return parseInt(cleanedHex.length % 2 ? l + l : l, 16);
    })
    .concat(Number.isFinite(opacity) ? opacity : 1)
    .join(',')})`;
  return rgbaColor;
};

export { hexToRGBA };
